<ion-content [fullscreen]="true" *ngIf="provider$ | async as provider">

  <app-header [provider]="provider"></app-header>

  <ng-container *ngIf="articles$ | async as articles">


<div class="content nopadding">
  <div class="bigblock yellow_dark">
    <div class="slider" *ngIf="articles?.[0] as article">
      <h1>Aktualno</h1>
      <div class="block">
        <div class="left"><img src="{{ article?.avatar?.url || getImageUrl(article?.id) || 'https://docs.api.pricepilot.io/652dadba274e4.jpeg' }}" alt="{{article?.topic}} - {{article?.name}} - {{article?.shortLead}} | dm Studio"></div>
        <div class="right">
          <i class="uppercase">{{ article.topic }}</i>
          <b>{{ article.name }}</b>
          <span>{{ article.shortLead }}</span>
          <div [routerLink]="['/', 'aktualno', article?.slug]" class="button clickable">VEČ</div>
        </div>
      </div>
      <div class="nav">
        <div class="item active"></div>
        <!--div class="item"></div>
        <div class="item"></div-->
      </div>
    </div>
  </div>
</div>

<!-- <div class="content">
  <div class="chip mt-40">
    <div class="inner">
      <a href="#" [ngClass]="{'sel': !topicSlug }" [routerLink]="['/', 'aktualno']" [queryParams]="{}">Vse tematike</a>
      <a href="#" [ngClass]="{'sel': topicSlug === 'microneedling' }" [routerLink]="['/', 'aktualno']" [queryParams]="{ tema: 'microneedling' }" >Microneedling</a>
      <a href="#" [ngClass]="{'sel': topicSlug === 'nega-las' }" [routerLink]="['/', 'aktualno']" [queryParams]="{ tema: 'nega-las' }" >Nega las</a>
      <a href="#" [ngClass]="{'sel': topicSlug === 'darilni-boni' }" [routerLink]="['/', 'aktualno']" [queryParams]="{ tema: 'darilni-boni' }" >Darilni boni</a>
      <!--a href="#">Novosti</a>
      <a href="#">Kozmetični izdelki</a>
      <a href="#">Tema XY</a->
    </div>
  </div>
</div> -->

<div class="content nopadding">
  <div class="aktualno white">
    <div [routerLink]="['/', 'aktualno', article?.slug]" class="item clickable" *ngFor="let article of articles | slice: 1"><div class="img">
      <img src="{{ article?.avatar?.url || getImageUrl(article?.id) || 'https://docs.api.pricepilot.io/652dadba274e4.jpeg' }}"  alt="{{article?.topic}} - {{article?.name}} - {{article?.shortLead}} | dm Studio"></div><i class="uppercase">{{ article.topic }}</i><b>{{ article.name }}</b><span>{{ article.shortLead }}</span></div>
  </div>
</div>

<!--div class="content nopadding">
  <div class="items">
    <div class="spacer_1 mt-30 mb-30"></div>
    <h2 class="mb-40">POVEZANA PONUDBA</h2>
    <div class="flex">
      <div class="item blue"><div class="new">NOVO</div><div class="img"><img src="img/item_1.png"></div><div class="vertical">FRIZERSKE STORITVE</div><b>Žensko striženje - do ramen</b><div class="bag"></div><div class="discount">50 EUR</div><div class="price"><span>42</span> EUR</div></div>
      <div class="item yellow"><div class="img"><img src="img/item_2.png"></div><div class="vertical">FRIZERSKE STORITVE</div><b>Barvanje narastka - lasje do ramen</b><div class="bag"></div><div class="discount"></div><div class="price"><span>55</span> EUR</div></div>
      <div class="item blue"><div class="img"><img src="img/item_3.png"></div><div class="vertical">FRIZERSKE STORITVE</div><b>Fen frizura - lasje od ramen</b><div class="bag"></div><div class="discount"></div><div class="price"><span>55</span> EUR</div></div>
      <div class="item fuksia"><div class="img"><img src="img/item_4.png"></div><div class="vertical">KOZMETIČNE STOROTVE</div><b>Nega nog - Medicinska pedikura</b><div class="bag"></div><div class="discount">66 EUR</div><div class="price"><span>49</span> EUR</div></div>
    </div>
  </div>
</div-->

<!--div class="spacer_4 mt-30"></div>

<div class="content nopadding">
  <div class="aktualno white">
    <div class="item"><div class="img"><img src="assets/img/img_2.png"></div><i>NEGA KOŽE</i><b>Paž frizure 2023: sveže ideje za preobrazbo</b><span>Paž frizure se vračajo v velikem slogu z dodatkom prefinjenih detajlov.</span></div>
    <div class="item"><div class="img"><img src="assets/img/img_3.png"></div><i>NEGA KOŽE</i><b>Paž frizure 2023: sveže ideje za preobrazbo</b><span>Paž frizure se vračajo v velikem slogu z dodatkom prefinjenih detajlov.</span></div>
    <div class="item"><div class="img"><img src="assets/img/img_4.png"></div><i>NEGA KOŽE</i><b>Privoščite si nego las s pilingom lasišča in fen frizuro</b><span>Paž frizure se vračajo v velikem slogu z dodatkom prefinjenih detajlov.</span></div>
  </div>
</div>

<div class="content">
  <div class="showmore mt-40">
    <div class="info">Prikazanih 12 od 33 objav</div>
    <div class="c"></div>
    <div class="bar mt-20 mb-20"><div class="inside"></div></div>
    <div class="c"></div>
    <div class="button">PRIKAŽI VEČ</div>
  </div>
</div -->


  </ng-container>

  <app-footer [provider]="provider"></app-footer>

  <app-cart [provider]="provider"></app-cart>

</ion-content>
